export const KASPI = Object.freeze({
  isMultilanguageEnabled: true,
  defaultLocale: 'ru-RU',
  mobapp: window.mobapp,
  userAgent: window.navigator.userAgent,
  authCallbacks: {
    isAuthorized: 'window.authCallbacks.isAuthorized',
    authSuccessCallback: 'window.authCallbacks.authSuccessCallback',
    authFailureCallback: 'window.authCallbacks.authFailureCallback'
  }
})

export const KASPI_COOKIES = Object.freeze({
  kaspiPaymentRegion: 'kaspi-payment-region',
  userDeviceType: 'user-device-type',
  mobAppVersion: 'mobapp_version',
  testUserGroup: 'test.user.group'
})

export const KASPI_PRODUCTS = Object.freeze({
  SOCIAL: 'social',
  GOLDKID: 'goldkid'
})

export const KASPI_AB = Object.freeze({
  ABTEST_GOLDKID_LANDING: {
    test: [31, 60],
    control: [1, 30]
  },
  ABTEST_GOLDKID_TYP: {
    test: [51, 100],
    control: [1, 50]
  },
  AB_REJECT_WINDOW: {
    test: [51, 100],
    control: [1, 50]
  }
})
